import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
  Users, BookOpen, MessageSquare, Shield, BarChart3, Settings, Menu, Sun, Moon, Bell, User, 
  GraduationCap, LogOut, ChevronDown, X, Calendar, TrendingUp, AlertCircle,
  FileText,
  Users2,
  UserPlus,
  Code,
  Settings2,
  List
} from 'lucide-react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { logout } from '../redux/slices/authSlice';

import { getMessaging, onMessage } from "firebase/messaging";
import { messaging } from '../firebaseConfig';
// import notificationSound from "././sounds/notification.wav";

const DashboardLayout = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [darkMode, setDarkMode] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: BarChart3, path: '/dashboard' },
    { id: 'teachers', label: 'Teachers', icon: Users2, path: '/teachers' },
    { id: 'classes', label: 'Classes', icon: BookOpen, path: '/classes' },
    { id: 'add-student', label: 'Add Students', icon: UserPlus, path: '/add-student' },
    { id: 'all-students', label: 'All Students', icon: Users, path: '/all-students' },
    // { id: 'result-codes', label: 'Result Codes', icon: Code, path: '/result-codes' },
    { id: 'results', label: 'Results', icon: FileText, path: '/results' },
    { id: 'generate-performance', label: 'Performances', icon: List, path: '/generate-performance' },
    { id: 'profile', label: 'Profile', icon: Settings2, path: '/profile' },
    // { id: 'attendance', label: 'Attendance', icon: Calendar, path: '/attendance' },
    // { id: 'assignments', label: 'Assignments', icon: GraduationCap, path: '/assignments' },
    // { id: 'grades', label: 'Grades', icon: TrendingUp, path: '/grades' },
    // { id: 'reports', label: 'Reports', icon: AlertCircle, path: '/reports' },
    // { id: 'messages', label: 'Messages', icon: MessageSquare, path: '/messages' },
    // { id: 'settings', label: 'Settings', icon: Settings, path: '/settings' }
  ];

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
  }, [darkMode]);

  // useEffect(() => {
  //   // const messaging = getMessaging();

  //   onMessage(messaging, (payload) => {
  //     console.log("Foreground message:", payload);

  //     // Play sound
  //     const audio = new Audio('../../public/sounds/notification.wav');
  //     audio.play();

  //     // Show browser notification if needed
  //     new Notification(payload.notification.title, {
  //       body: payload.notification.body,
  //       icon: "/logo192.png",
  //     });
  //   });
  // }, []);

  
  const handleLogout = () => {
    // Clear auth token and Redux state
    localStorage.removeItem('authToken');
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div className={`min-h-screen bg-gray-50 dark:bg-gray-900 ${darkMode ? 'dark' : ''}`}>
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-lg text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        {isMobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>

      {/* Sidebar */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-40 w-64 bg-white dark:bg-gray-800 shadow-lg 
          transition-transform duration-300 ease-in-out
          ${sidebarCollapsed ? '!w-16' : ''}
          ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        {/* ... sidebar content unchanged ... */}
        <div className="flex items-center justify-between h-16 bg-gradient-to-r from-blue-500 to-indigo-600 px-4">
          <div className={`flex items-center space-x-2 transition-opacity duration-300 ${sidebarCollapsed ? 'opacity-0 w-0' : 'opacity-100'}`}>
            <BookOpen className="w-8 h-8 text-white" />
            <span className="text-xl font-bold text-white">Admin Portal</span>
          </div>
          {/* collapse btn - only show on desktop */}
          <button
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            className="p-2 rounded-lg text-white hover:bg-white/20 transition-colors flex-shrink-0 z-10 hidden lg:block"
          >
            <Menu className="w-5 h-5" />
          </button>
        </div>
        
        <nav className="mt-8 px-4">
          <div className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <button
                  key={item.id}
                  onClick={() => {
                    navigate(item.path);
                    setIsMobileMenuOpen(false); // Close mobile menu on navigation
                  }}
                  className={`w-full flex items-center ${sidebarCollapsed ? 'justify-center' : ''} px-4 py-3 text-left rounded-lg transition-colors ${
                    isActive
                      ? 'bg-blue-100 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400'
                      : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                  title={sidebarCollapsed ? item.label : ''}
                >
                  <Icon className={`w-5 h-5 flex-shrink-0 ${isActive ? 'text-blue-600 dark:text-blue-400' : 'text-gray-600 dark:text-gray-400'}`} />
                  <span className={`ml-3 transition-opacity duration-300 ${sidebarCollapsed ? 'opacity-0 w-0' : 'opacity-100'}`}>{item.label}</span>
                </button>
              );
            })}
          </div>
        </nav>
      </aside>

      {/* Main Content Wrapper - FULL WIDTH ON MOBILE */}
      <div
        className={`
          min-h-screen
          ${sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-64'} 
          pl-0 /* Critical: Reset padding/margin on mobile */
          transition-padding duration-300
        `}
      >
        {/* Top Navigation */}
        <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 h-16 sticky top-0 z-30">
          <div className="flex items-center justify-between px-6 h-full">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setDarkMode(!darkMode)}
                className="p-2 rounded-lg text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
              >
                {darkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
              </button>
            </div>

            <div className="flex items-center space-x-4">
              {/* Notifications */}
              <button className="p-2 rounded-lg text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 relative">
                <Bell className="w-5 h-5" />
                <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>
              </button>

              {/* Profile Dropdown */}
              <div className="relative">
                <button
                  onClick={() => setIsProfileOpen(!isProfileOpen)}
                  className="flex items-center space-x-2 p-2 rounded-lg text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
                >
                  <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900/20 rounded-full flex items-center justify-center">
                    <User className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                  </div>
                  <span className="hidden md:block text-sm font-medium text-gray-900 dark:text-white">
                    {user?.firstname || 'Teacher'}
                  </span>
                  <ChevronDown className="w-4 h-4" />
                </button>

                {isProfileOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 py-2 z-50">
                    <div className="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                      <p className="text-sm font-medium text-gray-900 dark:text-white">
                        {user?.firstname} {user?.lastname}
                      </p>
                      <p className="text-xs text-gray-600 dark:text-gray-400">
                        {user?.email || 'teacher@school.com'}
                      </p>
                    </div>
                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                    >
                      <LogOut className="w-4 h-4 mr-2" />
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </header>

        {/* Page Content - FULL WIDTH & RESPONSIVE PADDING */}
        <main className="bg-dark p-4 sm:p-6 w-full mx-auto max-w-full">
          <Outlet />
        </main>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </div>
  );
};

export default DashboardLayout; 